import { render } from "./orderClassification.vue?vue&type=template&id=3588dea0"
import script from "./orderClassification.vue?vue&type=script&lang=js"
export * from "./orderClassification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__